package haxe.ui.layouts;

class AbsoluteLayout extends DefaultLayout {
    public function new() {
        super();
    }

    private override function repositionChildren() {

    }
}